import useDevice from "@hooks/useDevice";
import { Paper } from "@mui/material";
import React from "react";

interface BasePaperContainerProps {
    children: React.ReactNode;
}

const BasePaperContainer: React.FC<BasePaperContainerProps> = ({ children }) => {
    const { isMobileDevice } = useDevice();
    return (
        <Paper
            sx={{
                p: !isMobileDevice ? {
                    xs: 2,
                    sm: 2,
                    md: 4,
                    lg: 6
                } : { xs: 0 },
                boxShadow: (theme) => isMobileDevice ? theme.shadows[0] : theme.shadows[1]
            }}
        >
            {children}
        </Paper>
    );
};

export default BasePaperContainer;